import { render, staticRenderFns } from "./MetricSectionList.vue?vue&type=template&id=109a7512&scoped=true"
import script from "./MetricSectionList.vue?vue&type=script&lang=js"
export * from "./MetricSectionList.vue?vue&type=script&lang=js"
import style0 from "./MetricSectionList.vue?vue&type=style&index=0&id=109a7512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109a7512",
  null
  
)

export default component.exports